// 多个页面所需要的选项
//分社
export const branch_office = [
  {
    id: 0,
    value: '全部'
  },
  {
    id: 1,
    value: '杭州'
  },
  {
    id: 2,
    value: '深圳'
  },
  {
    id: 3,
    value: '宁波'
  },
  {
    id: 99,
    value: '其他'
  }
];
// 线上学籍
export const online_student_status = [
  {
    id: 0,
    value: '全部'
  },
  {
    id: 1,
    value: '在籍'
  },
  {
    id: 2,
    value: '体验学籍'
  },
  {
    id: 3,
    value: '过期'
  },
  {
    id: 4,
    value: '无'
  },
  {
    id: 5,
    value: '注册'
  }
];
// 线下学籍
export const offline_student_status = [
  {
    id: 0,
    value: '全部'
  },
  {
    id: 1,
    value: '创训-已交付'
  },
  {
    id: 3,
    value: '创训-未交付'
  },
  {
    id: 2,
    value: '创商-已交付'
  },
  {
    id: 4,
    value: '创商-未交付'
  },
  {
    id: 99,
    value: '其他'
  },
  {
    id: -1,
    value: '无'
  }
];
// 合作
export const cooperation = [
  {
    id: 0,
    value: '全部',
    children: []
  },
  {
    id: 1,
    value: '学习中心',
    children: [
      {
        id: 2,
        value: '企业'
      }
    ]
  },
  {
    id: 3,
    value: '渠道',
    children: [
      {
        id: 4,
        value: '合伙人'
      },
      {
        id: 5,
        value: '个人渠道'
      }
    ]
  },
  {
    id: 6,
    value: '异业',
    children: []
  },
  {
    id: -1,
    value: '无',
    children: []
  }
];
//身份
export const identity = [
  {
    id: 0,
    value: '全部'
  },
  {
    id: 1,
    value: '领教'
  },
  {
    id: 2,
    value: '助教'
  },
  {
    id: 3,
    value: '辅导员'
  },
  {
    id: 4,
    value: '超级链接者'
  },
  {
    id: 99,
    value: '无'
  }
];
// 跟进状态
export const follow_status = [
  {
    id: '0',
    value: '全部'
  },
  {
    id: '1',
    value: '已加'
  },
  {
    id: '2',
    value: '团报'
  },
  {
    id: '3',
    value: '删'
  },
  {
    id: '4',
    value: '微信待通过'
  },
  {
    id: '5',
    value: '已发短信'
  },
  {
    id: '6',
    value: '微信非手机号'
  },
  {
    id: '7',
    value: '已电话沟通'
  },
  {
    id: '8',
    value: '活动分配'
  },
  {
    id: '99',
    value: '其他'
  },
  {
    id: '-1',
    value: '无'
  }
];
